var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideoCam = function SvgVideoCam(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 34,
    viewBox: "0 0 44 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1148 17.0025C30.1148 20.2573 30.1148 23.5118 30.1148 26.7658C30.1148 28.7777 28.9191 29.987 26.8831 29.9906C20.3 30.0009 13.7165 30.0009 7.13263 29.9906C5.24211 29.9906 4.00642 28.7397 4.00399 26.8526C3.99672 20.2779 3.99672 13.704 4.00399 7.13087C4.00642 5.25097 5.24332 4.00959 7.13627 4.00602C13.7202 3.99571 20.3036 3.99571 26.8867 4.00602C28.924 4.00602 30.1075 5.22005 30.11 7.23551C30.1156 10.4927 30.1172 13.7484 30.1148 17.0025ZM17.0958 26.6184C22.5818 26.591 26.8322 22.3568 26.8152 16.9347C26.7994 11.7028 22.4496 7.40792 17.1722 7.42219C11.7443 7.43646 7.50734 11.723 7.52796 17.1808C7.54736 22.3413 11.9081 26.6434 17.0958 26.6184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 6.8645V28.0084C39.3028 28.0773 38.6479 28.1558 37.9834 27.7111C36.407 26.6564 34.7881 25.6564 33.1752 24.6517C32.8114 24.4234 32.6502 24.1701 32.6514 23.7182C32.6708 19.5827 32.6708 15.4471 32.6514 11.3116C32.6514 10.8574 32.8151 10.6124 33.1813 10.3841C34.8487 9.34488 36.4761 8.24381 38.1738 7.25332C38.6661 6.96676 39.344 6.99292 40.0001 6.8645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3114 12.1272C20.1635 12.1272 22.4215 14.3685 22.4203 17.1949C22.4166 19.9024 20.1126 22.1521 17.3235 22.1521C16.6521 22.1521 15.9873 22.0225 15.367 21.7705C14.7467 21.5186 14.1831 21.1493 13.7084 20.6838C13.2336 20.2183 12.857 19.6657 12.6001 19.0575C12.3432 18.4493 12.2109 17.7974 12.2109 17.1391C12.2109 16.4807 12.3432 15.8288 12.6001 15.2206C12.857 14.6124 13.2336 14.0598 13.7084 13.5943C14.1831 13.1288 14.7467 12.7595 15.367 12.5076C15.9873 12.2556 16.6521 12.126 17.3235 12.126L17.3114 12.1272Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 44,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 26,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoCam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/videoCam.969f23ec.svg";
export { ForwardRef as ReactComponent };